import ResolutionMapper from './../../mappers/ResolutionMapper';
import ContentWrapper from './ContentWrapper';

type QuestionResolutionWrapperProps = {
  children?: React.ReactNode;
  resolutions?: any[];
  hasBottomBorder?: boolean;
  padding?: string | number;
  isVisible?: boolean;
  testId?: string;
  id?: string;
  hasTopBorder?: boolean;
  flex?: string;
};

export default function QuestionResolutionWrapper({
  children,
  resolutions = [],
  hasBottomBorder,
  hasTopBorder,
  padding,
  id = 'question-resolution-wrapper',
  isVisible,
  testId = 'question-resolution-wrapper',
  flex,
}: Readonly<QuestionResolutionWrapperProps>) {
  return (
    <ContentWrapper
      hasBottomBorder={hasBottomBorder}
      padding={padding}
      flex={flex}
      isVisible={isVisible}
      testId={testId}
      id={id}
      hasTopBorder={hasTopBorder}
    >
      {children}
      {resolutions.length > 0 && (
        <div>
          {resolutions.map((resolution) => (
            <ResolutionMapper
              key={resolution.name}
              resolution={resolution}
              style={{ marginTop: '0.5rem' }}
              isParentShowing={isVisible}
            />
          ))}
        </div>
      )}
    </ContentWrapper>
  );
}
